<template>
  <div class="clubcards">
    <div
      :id="`${idPrefix}-cards`"
      :ref="`${idPrefix}-cards`"
      class="clubcard__scroller"
      @scroll="updateByScroll"
    >
      <button v-if="selectedCard > 1" class="previous" @click="goToPrevCard">
        Prev
      </button>
      <button v-if="showNextArrow" class="next" @click="goToNextCard">
        Next
      </button>
      <ul
        :id="`${idPrefix}-card-list`"
        :ref="`${idPrefix}-card-list`"
        class="product-grid product-grid--clubcards"
      >
        <template v-for="(card, index) in cards">
          <li
            v-if="card.quote"
            :id="`${idPrefix}-${index + 1}`"
            :key="`${idPrefix}-${index + 1}`"
            class="clubcard clubcard--quote"
          >
            <blockquote>{{ card.quote }}</blockquote>
            <cite>{{ card.author_name }}</cite>
          </li>
          <AnimatedWineClubCard
            v-else
            :id="`${idPrefix}-${index + 1}`"
            :key="`${idPrefix}-${index + 1}`"
            :membership-type="card"
            :use-price-range="true"
            :mobile="mobile"
            :flipped="index === flippedIndex"
            @flip="flippedIndex = index"
          />
        </template>
      </ul>
    </div>
  </div>
</template>

<script>
import { defineAsyncComponent } from 'vue'

export default {
  name: 'WineClubCarousel',
  components: {
    AnimatedWineClubCard: defineAsyncComponent(
      () => import('@/components/Club/AnimatedWineClubCard.vue'),
    ),
  },
  props: {
    idPrefix: {
      type: String,
      default: 'wine-club',
      required: false,
    },
    membershipTypes: {
      type: Array,
      required: true,
    },
    quotes: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      selectedCard: 1,
      showNextArrow: true,
      sideOffset: 24,
      screenWidth: 0,
      mobile: true,
      flippedIndex: null,
    }
  },
  computed: {
    cards() {
      const cardData = []
      let quoteIndex = 0

      for (let i = 0; i < this.membershipTypes.length; i++) {
        cardData.push(this.membershipTypes[i])
        // Insert a quote every third membership type
        if ((i + 1) % 2 === 0 && quoteIndex < this.quotes.length) {
          cardData.push(this.quotes[quoteIndex])
          quoteIndex++
        }
      }
      return cardData
    },
  },
  watch: {
    screenWidth: {
      handler(newValue, oldValue) {
        this.mobile = newValue <= 640
        if (!this.mobile) this.flippedIndex = null
      },
      immediate: true,
    },
  },
  mounted() {
    // Initialize screen width
    this.updateScreenWidth()
    // Listen for window resize
    window.addEventListener('resize', this.updateScreenWidth)
  },
  beforeUnmount() {
    // Clean up event listener
    window.removeEventListener('resize', this.updateScreenWidth)
  },
  methods: {
    updateScreenWidth() {
      if (import.meta.client) {
        this.screenWidth = window.innerWidth
      }
    },
    goToNextCard() {
      this.$scrollTo(`#${this.idPrefix}-${this.selectedCard + 1}`, 500, {
        container: `#${this.idPrefix}-cards`,
        offset: -this.sideOffset,
        x: true,
        y: false,
      })
    },
    goToPrevCard() {
      this.$scrollTo(
        `#${this.idPrefix}-${Math.max(1, this.selectedCard - 1)}`,
        500,
        {
          container: `#${this.idPrefix}-cards`,
          offset: -this.sideOffset,
          x: true,
          y: false,
        },
      )
    },
    updateByScroll({ target: { scrollLeft, scrollWidth, clientWidth } }) {
      const firstWidth =
        this.$refs[`${this.idPrefix}-card-list`].children[0].scrollWidth
      const nthWidth =
        this.$refs[`${this.idPrefix}-card-list`].children[1].scrollWidth
      if (scrollLeft < firstWidth) {
        this.selectedCard = 1
      } else {
        this.selectedCard = Math.floor((scrollLeft - firstWidth) / nthWidth) + 2
      }
      this.showNextArrow =
        scrollLeft + this.sideOffset < scrollWidth - clientWidth
    },
  },
}
</script>
